import { Route, Redirect } from "react-router-dom";
import React, { Suspense, lazy, Fragment } from "react";
import Loader from "react-loaders";
import { ToastContainer } from "react-toastify";

const UserPages = lazy(() => import("../../Modules/UserPages"));
const Applications = lazy(() => import("../../Modules/Applications"));
const Dashboards = lazy(() => import("../../Modules/Dashboards"));
const Auth = lazy(() => import("../../Modules/Auth/Auth"));
const Properties = lazy(() => import("../../Modules/Properties"));
const Verification = lazy(() => import("../../Modules/Verification"));
// const State = lazy(() => import("../../Modules/State/StateList"));
const Users = lazy(() => import("../../Modules/Users"));
const Advertisement = lazy(() => import("../../Modules/Advertisement"));
const Masters = lazy(() => import("../../Modules/Masters"));
const Landmark = lazy(() => import("../../Modules/Landmark"));
const Settings = lazy(() => import("../../Modules/Settings"));

const Widgets = lazy(() => import("../../Modules/Widgets"));
const Elements = lazy(() => import("../../Modules/Elements"));
const Components = lazy(() => import("../../Modules/Components"));
const Charts = lazy(() => import("../../Modules/Charts"));
const Forms = lazy(() => import("../../Modules/Forms"));
const Tables = lazy(() => import("../../Modules/Tables"));


const AppMain = () => {

    return (
        <Fragment>
            
            <Route exact path="/" render={() => (
                <Redirect to="/"/>
            )}/>
            
            {/* Auth */}

            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            {/* <Loader type="ball-spin-fade-loader" /> */}
                        </div>
                    </div>
                </div>
            }>
                <Route path="/" component={Auth}/>
            </Suspense>

            {/* Components */}

            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            {/* <Loader type="ball-spin-fade-loader" /> */}
                        </div>
                    </div>
                </div>
            }>
                <Route path="/components" component={Components}/>
            </Suspense>

            {/* Forms */}

            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            {/* <Loader type="ball-spin-fade-loader" /> */}
                        </div>
                    </div>
                </div>
            }>
                <Route path="/forms" component={Forms}/>
            </Suspense>

            {/* Charts */}

            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            {/* <Loader type="ball-spin-fade-loader" /> */}
                        </div>
                    </div>
                </div>
            }>
                <Route path="/charts" component={Charts}/>
            </Suspense>

            {/* Tables */}

            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            {/* <Loader type="ball-spin-fade-loader" /> */}
                        </div>
                    </div>
                </div>
            }>
                <Route path="/tables" component={Tables}/>
            </Suspense>

            {/* Elements */}

            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            {/* <Loader type="ball-spin-fade-loader" /> */}
                        </div>
                    </div>
                </div>
            }>
                <Route path="/elements" component={Elements}/>
            </Suspense>

            {/* Dashboard Widgets */}

            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            {/* <Loader type="ball-spin-fade-loader" /> */}
                        </div>
                    </div>
                </div>
            }>
                <Route path="/widgets" component={Widgets}/>
            </Suspense>

            {/* Pages */}

            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            {/* <Loader type="ball-spin-fade-loader" /> */}
                        </div>
                    </div>
                </div>
            }>
                <Route path="/pages" component={UserPages}/>
            </Suspense>

            {/* Applications */}

            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            {/* <Loader type="ball-spin-fade-loader" /> */}
                        </div>
                    </div>
                </div>
            }>
                <Route path="/apps" component={Applications}/>
            </Suspense>

            {/* Dashboards */}

            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            {/* <Loader type="ball-spin-fade-loader" /> */}
                        </div>
                    </div>
                </div>
            }>
                <Route path="/dashboards" component={Dashboards}/>
            </Suspense>

            {/* Properties */}

            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            {/* <Loader type="ball-spin-fade-loader" /> */}
                        </div>
                    </div>
                </div>
            }>
                <Route path="/properties" component={Properties}/>
            </Suspense>

            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            {/* <Loader type="ball-spin-fade-loader" /> */}
                        </div>
                    </div>
                </div>
            }>
                <Route path="/verification" component={Verification}/>
            </Suspense>

            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            {/* <Loader type="ball-spin-fade-loader" /> */}
                        </div>
                    </div>
                </div>
            }>
                <Route path="/users" component={Users}/>
            </Suspense>

            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            {/* <Loader type="ball-spin-fade-loader" /> */}
                        </div>
                    </div>
                </div>
            }>
                <Route path="/advertisement" component={Advertisement}/>
            </Suspense>

            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            {/* <Loader type="ball-spin-fade-loader" /> */}
                        </div>
                    </div>
                </div>
            }>
                <Route path="/masters" component={Masters}/>
            </Suspense>

            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            {/* <Loader type="ball-spin-fade-loader" /> */}
                        </div>
                    </div>
                </div>
            }>
                <Route path="/landmarks" component={Landmark}/>
                {/* <Route path="/State" component={State}/> */}
            </Suspense>

            <Suspense fallback={
                <div className="loader-container">
                    <div className="loader-container-inner">
                        <div className="text-center">
                            {/* <Loader type="ball-spin-fade-loader" /> */}
                        </div>
                    </div>
                </div>
            }>
                <Route path="/settings" component={Settings}/>
            </Suspense>


            {/* <Route exact path="/" render={() => (
                <Redirect to="/"/>
            )}/> */}
            <ToastContainer/>
        </Fragment>
    )
};

export default AppMain;
